import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDesign } from '../contexts/DesignContext';
import { useSteps } from '../hooks/useSteps';
import giftIcon from '../assets/gift.svg';

const ProgressStepper = ({ currentStep, totalSteps, visibleSteps }) => {
  const [stepWidth, setStepWidth] = useState(0);
  const { t } = useTranslation();
  const { isNewDesign } = useDesign();
  const { isShortMode, isCarouselMode } = useSteps();

  // Step labels - зависят от режима
  const stepLabels = isNewDesign
    ? isShortMode
      ? isCarouselMode
        ? ['Style', 'Ethnicity', 'Body', 'Breast', 'Ass', 'Kinks', 'Result']
        : ['Style', 'Ethnicity', 'Body', 'Kinks', 'Result']
      : isCarouselMode
      ? [
          'Style',
          'Ethnicity',
          'Body',
          'Breast',
          'Ass',
          'Hair',
          'Voice',
          'Result',
        ]
      : ['Style', 'Ethnicity', 'Body', 'Hair', 'Voice', 'Result']
    : ['Style', 'Ethnicity', 'Body', 'Hair', 'Voice', 'Result'];

  // Calculate the visible current step (excluding hidden steps)
  const getVisibleCurrentStep = () => {
    let visibleStep = 0;
    const hiddenSteps = isNewDesign ? [7, 8, 9] : [6, 7, 8];
    for (let i = 0; i <= currentStep; i++) {
      if (!hiddenSteps.includes(i)) {
        visibleStep++;
      }
    }
    return visibleStep - 1; // Subtract 1 because we want 0-based index
  };

  const visibleCurrentStep = getVisibleCurrentStep();

  // Calculate step width.
  // Desktop: fixed 120px per step (per design). Mobile: distribute across the
  // 355px container width.
  const getStepWidth = () => {
    if (window.innerWidth > 768) return 120;
    const containerWidth = 355;
    const gap = 4;
    const totalGaps = totalSteps - 1;
    const availableWidth = containerWidth - totalGaps * gap;
    return availableWidth / totalSteps;
  };
  console.log('currentStep', currentStep);
  console.log('totalSteps', totalSteps);

  useEffect(() => {
    const updateStepWidth = () => {
      const newWidth = getStepWidth();
      console.log(
        'ProgressStepper: Container width:',
        window.innerWidth > 768 ? 505 : 355,
        'Step width:',
        newWidth,
        'Total steps:',
        totalSteps,
      );
      setStepWidth(newWidth);
    };

    // Set initial width
    updateStepWidth();

    // Add resize listener
    window.addEventListener('resize', updateStepWidth);

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateStepWidth);
    };
  }, [totalSteps]);

  if (isNewDesign) {
    return (
      <div className="progress-stepper">
        {currentStep === totalSteps - 1 ? (
          <div className="progress-stepper-text">
            <img src={giftIcon} alt="" width={12} height={12} />
            {t('limited_offer')}{' '}
            <span className="highlight-text">{t('offer_price')}</span>
            <img src={giftIcon} alt="" width={12} height={12} />
          </div>
        ) : (
          <>
            <div className="progress-stepper-bars">
              {Array.from({ length: totalSteps }, (_, index) => (
                <div
                  key={index}
                  className="progress-step"
                  style={{ width: `${stepWidth}px` }}
                >
                  <div
                    className={`progress-bar ${
                      index <= visibleCurrentStep ? 'progress-filled' : ''
                    }`}
                  />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="progress-stepper">
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className="progress-step"
          style={{ width: `${stepWidth}px` }}
        >
          <div
            className={`progress-bar ${
              index <= visibleCurrentStep ? 'progress-filled' : ''
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default ProgressStepper;
